/* eslint-disable no-case-declarations */
import {
  GET_UPLOAD_IMAGE,
  UPDATE_UPLOAD_IMAGE_SUCCESS,
  REMOVE_UPLOAD_IMAGE_SUCCESS,
  REMOVE_IMAGE_LOADING,
  REMOVE_UPLOAD_IMAGE_BACKGROUND,
  UPDATE_IMAGE_LOADING,
  UPDATE_UPLOAD_IMAGE_ERROR_INFO,
  REMOVE_UPLOAD_IMAGE_ERROR_INFO,
  UPDATE_UPLOAD_IMAGE_LOCKED_INFO,
  UPDATE__IMAGE_SIZE,
  UPDATE__IMAGE_PLACEMENT,
  UPDATE_URL_FOR_UPLOAD_IMAGES,
  UPDATE_URL_FOR_UPLOAD_IMAGES_ON_ATB,
  GET_COLOR_LOGO,
  UPDATE_LOGO_TAB,
  SAVE_UPDATED_LOGO_COLOR_COUNT,
  SHOW_UPLOAD_IMAGE_ERROR,
  UPDATE_COPY_LOGO,
} from '../actions/actionTypes';
import {
  getSpecificUploadImage,
  getOtherImages,
  findUploadImagePositionInString,
  getUploadedPositions,
  getUnUploadedPositions,
  getFileExtension,
  updateUploadImageChooseOptions,
  getUpdatedImagesUrlOnATB,
} from '../utils/uploadImagesUtil';

const initialState = {
  uploadImagesUrl: null,
  logoColors: 1,
  isLockedTextVisible: false,
  uploadImageErrorInfo: {
    showUploadImageError: false,
    uploadImageErrorMessage: null,
  },
  uploadImageShowError: false,
  uploadImages: [
    {
      id: 1,
      uploadImageTabName: 'Front',
      uploadedImageFileName: null,
      uploadedImageUrl: null,
      showUploadRemoveButton: false,
      toggleRemoveBackground: false,
      enableRemoveBackground: false,
      isImageLoading: false,
      imageSize: 'Large',
      imagePlacement: 'Center',
      imagePlacementValue: 'Middle',
    },
  ],
  currentTab: 'Front',
  isCopyLogo: true,
};

export default (state = initialState, action) => {
  const currentImage = getSpecificUploadImage(action.payload?.id, state.uploadImages);
  const otherImages = getOtherImages(action.payload?.id, state.uploadImages);
  let updatedImage = {};
  let updatedUploadUrl;
  switch (action.type) {
    case GET_UPLOAD_IMAGE:
      return {
        ...state,
        uploadImages: action.payload,
      };
    case UPDATE_UPLOAD_IMAGE_SUCCESS:
      updatedImage = {
        ...currentImage,
        uploadedImageFileName: action.payload.fileName,
        uploadedImageUrl: action.payload.fileUrl,
        showUploadRemoveButton: action.payload.showUploadRemoveButton,
        enableRemoveBackground: true,
        isImageLoading: action.payload.isImageLoading,
      };

      const usedColorsCount =
        action.payload?.colorData?.usedColorsCount <= action.payload.maxColorsToUse
          ? action.payload?.colorData?.usedColorsCount
          : action.payload.maxColorsToUse;

      if (action.payload?.colorData) {
        updatedImage = {
          ...updatedImage,
          logoColors: usedColorsCount,
          colorData: { ...action.payload?.colorData },
        };
      }

      const { lineItemId, uploadType, ppeFileType, logoPosition } = action.payload;

      const fileExtension = getFileExtension(action.payload.fileName);
      const imagePlacementValue = updatedImage.imagePlacementValue
        ? updatedImage.imagePlacementValue[0]
        : 'none';
      const imageSize = updatedImage.imageSize ? updatedImage.imageSize[0] : 'none';
      const logoColor = updatedImage.logoColors ?? 1;

      if (!action.payload.uploadImagesUrl) {
        updatedUploadUrl = `${lineItemId}-${uploadType}-${ppeFileType},${logoPosition}-F-${imageSize}-${imagePlacementValue}-${logoColor}-${fileExtension}`;
      } else {
        updatedUploadUrl = `${action.payload.uploadImagesUrl},${logoPosition}-F-${imageSize}-${imagePlacementValue}-${logoColor}-${fileExtension}`;
      }
      let uploadImageParam = updatedUploadUrl.split(',');
      uploadImageParam = [...new Set(uploadImageParam)]; // removing duplicates
      updatedUploadUrl = uploadImageParam.join(',');
      return {
        ...state,
        uploadImages: [...otherImages, updatedImage],
        uploadImagesUrl: updatedUploadUrl,
        uploadImageShowError: false,
      };
    case REMOVE_UPLOAD_IMAGE_SUCCESS:
      updatedImage = {
        ...currentImage,
        uploadedImageFileName: null,
        uploadedImageUrl: null,
        showUploadRemoveButton: action.payload.showUploadRemoveButton,
        enableRemoveBackground: action.payload.enableRemoveBackground,
        toggleRemoveBackground: action.payload.toggleRemoveBackground,
        isImageLoading: action.payload.isImageLoading,
        logoColors: 1,
      };
      updatedUploadUrl = action.payload.uploadImagesUrl.split(',');
      const position = action.payload?.logoPosition ?? 'none';
      updatedUploadUrl = updatedUploadUrl
        .filter((item) => !item.includes(position.toLowerCase()))
        .join(',');
      if (findUploadImagePositionInString(updatedUploadUrl).length === 0) {
        updatedUploadUrl = null;
      }
      return {
        ...state,
        uploadImages: [...otherImages, updatedImage],
        uploadImagesUrl: updatedUploadUrl,
      };
    case REMOVE_UPLOAD_IMAGE_BACKGROUND:
      updatedImage = {
        ...currentImage,
        toggleRemoveBackground: action.payload.toggleRemoveBackground,
      };
      updatedUploadUrl = updateUploadImageChooseOptions(
        updatedImage,
        action.payload.uploadImagesUrl,
        action.payload.logoPosition
      );
      return {
        ...state,
        uploadImages: [...otherImages, updatedImage],
        uploadImagesUrl: updatedUploadUrl,
      };
    case UPDATE__IMAGE_SIZE:
      updatedImage = {
        ...currentImage,
        imageSize: action.payload.imageSize,
      };
      if (updatedImage.uploadedImageFileName) {
        updatedUploadUrl = updateUploadImageChooseOptions(
          updatedImage,
          action.payload.uploadImagesUrl,
          action.payload.logoPosition
        );
      }
      return {
        ...state,
        uploadImages: [...otherImages, updatedImage],
        uploadImagesUrl: updatedUploadUrl,
      };
    case UPDATE__IMAGE_PLACEMENT:
      updatedImage = {
        ...currentImage,
        imagePlacement: action.payload.imagePlacement,
        imagePlacementValue: action.payload.imagePlacementValue,
      };
      if (updatedImage.uploadedImageFileName) {
        updatedUploadUrl = updateUploadImageChooseOptions(
          updatedImage,
          action.payload.uploadImagesUrl,
          action.payload.logoPosition
        );
      }
      return {
        ...state,
        uploadImages: [...otherImages, updatedImage],
        uploadImagesUrl: updatedUploadUrl,
      };
    case UPDATE_IMAGE_LOADING:
      updatedImage = {
        ...currentImage,
        isImageLoading: action.payload.isImageLoading,
      };
      return {
        ...state,
        uploadImages: [...otherImages, updatedImage],
      };
    case REMOVE_IMAGE_LOADING:
      updatedImage = {
        ...currentImage,
        isImageLoading: action.payload.isImageLoading,
      };
      return {
        ...state,
        uploadImages: [...otherImages, updatedImage],
      };
    case UPDATE_UPLOAD_IMAGE_ERROR_INFO:
      return {
        ...state,
        uploadImageErrorInfo: {
          showUploadImageError: action.payload.showUploadImageError,
          uploadImageErrorMessage: action.payload.uploadImageErrorMessage,
        },
      };
    case REMOVE_UPLOAD_IMAGE_ERROR_INFO:
      return {
        ...state,
        uploadImageErrorInfo: {
          showUploadImageError: action.payload.showUploadImageError,
          uploadImageErrorMessage: action.payload.uploadImageErrorMessage,
        },
      };
    case UPDATE_UPLOAD_IMAGE_LOCKED_INFO:
      return {
        ...state,
        isLockedTextVisible: action.payload.isLockedTextVisible,
      };
    case GET_COLOR_LOGO:
      updatedImage = {
        ...currentImage,
        logoColors: action.payload.logoColors,
      };
      if (updatedImage.uploadedImageFileName) {
        updatedUploadUrl = updateUploadImageChooseOptions(
          updatedImage,
          action.payload.uploadImagesUrl,
          action.payload.logoPosition
        );
      }
      return {
        ...state,
        uploadImages: [...otherImages, updatedImage],
        uploadImagesUrl: updatedUploadUrl,
      };

    case UPDATE_URL_FOR_UPLOAD_IMAGES:
      const uploadedPositions = getUploadedPositions(
        action.payload.uploadImageParams,
        action.payload.uploadedImages
      );
      const unUploadedPositions = getUnUploadedPositions(state.uploadImages, uploadedPositions);
      const updatedLineItemId = action.payload.guid.split('-').join('_');
      updatedUploadUrl = `${updatedLineItemId}-${action.payload.uploadImageParams.uploadType}-${
        action.payload.uploadImageParams.ppeFileType
      },${action.payload.uploadImageParams.params.join(',')}`;
      return {
        ...state,
        uploadImagesUrl: updatedUploadUrl,
        uploadImages: [...unUploadedPositions, ...uploadedPositions],
      };

    case UPDATE_URL_FOR_UPLOAD_IMAGES_ON_ATB:
      updatedUploadUrl = getUpdatedImagesUrlOnATB(
        action.payload.lineItemId,
        action.payload.uploadImagesUrl
      );
      return {
        ...state,
        uploadImagesUrl: updatedUploadUrl,
      };

    case UPDATE_LOGO_TAB: {
      const selectedTab = action.payload;
      return { ...state, currentTab: selectedTab };
    }

    case SAVE_UPDATED_LOGO_COLOR_COUNT:
      const logoPositionToUpdate = action.payload.logoPosition.toLowerCase();
      const matchingLogoData = state.uploadImages.find(
        (image) => image.uploadImageTabName.toLowerCase() === logoPositionToUpdate
      );
      const updatedImageData = state.uploadImages.filter(
        (img) => img.uploadImageTabName.toLowerCase() !== logoPositionToUpdate
      );
      updatedImageData.push({
        ...matchingLogoData,
        logoColors: action.payload.newColorCount,
      });
      return {
        ...state,
        uploadImages: updatedImageData,
      };

    case SHOW_UPLOAD_IMAGE_ERROR: {
      return { ...state, uploadImageShowError: action.payload };
    }

    case UPDATE_COPY_LOGO: {
      return { ...state, isCopyLogo: action.payload.isCopyLogo };
    }

    default:
      return state;
  }
};
